const SECTION_ID = 'store-page-section-a';
const DESKTOP_FILTER_CLASS = 'desktop-filter';
const MOBILE_FILTER_CLASS = 'mobile-filter';
const CATEGORY_CLASS = 'product-category';
const PRODUCT_WRAPPER_CLASS = 'product-wrapper';
const PRODUCT_LIST_CLASS = 'product-list';

class FilterStorePage {
    constructor() {
        this._section = document.getElementById(SECTION_ID);

        this._section && this._run();
    }
    _run() {
        this._desktopFilter = this._section.querySelector(`.${DESKTOP_FILTER_CLASS}`);
        this._mobileFilter = this._section.querySelector(`.${MOBILE_FILTER_CLASS}`);
        this._productList = this._section.querySelector(`.${PRODUCT_LIST_CLASS}`);
        this._productWrappers = this._section.querySelectorAll(`.${PRODUCT_WRAPPER_CLASS}`);

        this._desktopFilter.addEventListener('click', this._runDesktopFilter.bind(this));
        this._mobileFilter.addEventListener('change', this._runMobileFilter.bind(this));
    }
    _runDesktopFilter(e) {
        let element = e.target;

        if (element.dataset.slug) {
            this._desktopFilter.querySelectorAll('a').forEach((item) => {
                item.dataset.active = '';
            });
            this._desktopFilter.dataset.active = element.dataset.slug;
            element.dataset.active = true;

            this._filter(element.dataset.slug);
        }
    }
    _runMobileFilter(e) {
        let category = 'all';
        if (e.detail.value) {
            category = e.detail.value;
        }
        this._filter(category);
    }
    _filter(category) {
        if (category) {
            this._productWrappers.forEach((productWrapper) => {
                productWrapper.classList.add('hidden');
                productWrapper.classList.add('opacity-0');
                productWrapper.removeAttribute('data-active');
            });
            this._productWrappers.forEach((productWrapper) => {
                if (productWrapper.dataset.category === category || category == 'all') {
                    productWrapper.classList.remove('hidden');

                    if (category === 'all') {
                        productWrapper.removeAttribute('data-active');
                    } else {
                        productWrapper.dataset.active = true;
                    }
                    setTimeout(
                        () => {
                            requestAnimationFrame(() => {
                                productWrapper.classList.remove('opacity-0');
                            });
                        },
                        parseFloat(getComputedStyle(productWrapper).transitionDuration) * 1000,
                    );
                }
            });
        }
    }
}

const filterStorePage = new FilterStorePage();
